<cm-full-page-feedback class="cm-full-page-feedback" [icon]="$feedbackIcon()" text="Verifying SSO login"></cm-full-page-feedback>
